import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API, RISKMGT } from '@const'
import * as utils from '@utils'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Divider from '@material-ui/core/Divider'
import { TextField, Grid, InputAdornment } from '@material-ui/core'

class EditRiskRuleBigRichDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'EditRiskRuleBigRichDialog', options)
        }
    }

    state = {
        input: {},
        dialogOpen: false,
        isLoading: false,
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    OpenDialog(params) {
        const bigRichRiskRule = params.riskRuleLsit[utils.ComposeRiskRuleKey(RISKMGT.RISK_ROLE_BIG_RICH, params.pfSubPfId)]

        this.setState({
            input: {
                accumulated_days: bigRichRiskRule.accumulated_days,
                bet_rank_above: bigRichRiskRule.bet_rank_boundary[1],
                expired_days: bigRichRiskRule.expired_days,
            },
            riskRuleLsit: params.riskRuleLsit,
            pfSubPfId: params.pfSubPfId,
            isLoading: false,
        })
        this.setState({ dialogOpen: true })
    }

    closeDialog() {
        this.setState({ dialogOpen: false })
    }

    confirm() {
        const bigRichRiskRule = this.state.riskRuleLsit[utils.ComposeRiskRuleKey(RISKMGT.RISK_ROLE_BIG_RICH, this.state.pfSubPfId)]

        utils.apiRequest(
            'patch',
            API.RISKMGT_RISK_RULE,
            {
                id: bigRichRiskRule.id,
                accumulated_days: parseInt(this.state.input.accumulated_days),
                bet_rank_boundary: [0, parseInt(this.state.input.bet_rank_above)],
                expired_days: parseInt(this.state.input.expired_days),
            },
            (_data) => {
                this.props.confirmCallback()
                this.closeDialog()
            }
        )
    }

    render() {
        return (
            <Dialog open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })}>
                <DialogTitle>{this.t('Title')}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={3}>
                            <TextField
                                label={this.t('accumulatedDays')}
                                value={this.state.input.accumulated_days}
                                onChange={(event) => {
                                    let value = parseInt(event.target.value)
                                    if (value < 1 || isNaN(value)) {
                                        value = 1
                                    }

                                    this.setState({
                                        input: {
                                            ...this.state.input,
                                            accumulated_days: value,
                                        },
                                    })
                                }}
                                margin="dense"
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <TextField
                                fullWidth
                                label={this.t('betRankAbove')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.input.bet_rank_above}
                                onChange={(event) => {
                                    let value = parseInt(event.target.value)
                                    if (value < 0 || isNaN(value)) {
                                        value = 0
                                    } else if (value >= 100) {
                                        value = 100
                                    }

                                    this.setState({
                                        input: {
                                            ...this.state.input,
                                            bet_rank_above: value,
                                        },
                                    })
                                }}
                                margin="dense"
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                }}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                label={this.t('expiredDays')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.input.expired_days}
                                onChange={(event) => {
                                    let value = parseInt(event.target.value)
                                    if (value < 1 || isNaN(value)) {
                                        value = 1
                                    }

                                    this.setState({
                                        input: {
                                            ...this.state.input,
                                            expired_days: value,
                                        },
                                    })
                                }}
                                margin="dense"
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={() => {
                            this.setState({ isLoading: true })
                            this.confirm()
                        }}
                        color="primary"
                        disabled={this.state.isLoading}>
                        {this.t('confirm')}
                    </Button>
                    <Button variant="contained" onClick={() => this.closeDialog()} color="secondary">
                        {this.t('cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const styles = (_theme) => {
    return {}
}

EditRiskRuleBigRichDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    confirmCallback: PropTypes.func,
}

export default hoc(styles)(EditRiskRuleBigRichDialog)
